module.exports = __webpack_public_path__ + "static/media/lien.b36637ce.svg";